var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemoveDye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33 26C33 31.5228 28.5228 36 23 36C17.4772 36 13 31.5228 13 26C13 20.4772 23 9 23 9C23 9 33 20.4772 33 26Z",
    fill: "#003E6B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34,
    cy: 34,
    r: 7,
    fill: "#ED3431",
    stroke: "#ED3431",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34 35.4142L36.8284 38.2426L38.2427 36.8284L35.4142 34L38.2427 31.1716L36.8284 29.7574L34 32.5858L31.1716 29.7574L29.7574 31.1716L32.5858 34L29.7574 36.8284L31.1716 38.2426L34 35.4142Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveDye);
export default __webpack_public_path__ + "static/media/remove_dye.44f049d18238cc59f1113d6c57021d0b.svg";
export { ForwardRef as ReactComponent };